module.exports = __webpack_public_path__ + "img/case_history.6d3abf1f.svg";